exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n}\n\n.animation-toolbar {\n  -ms-flex-align: center;\n      align-items: center;\n  background: #f6f9fc;\n  border: 1px solid #dbe4ef;\n  border-bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n}\n\n.animation-toolbar button {\n  background: #ffffff;\n  border: 1px solid #cbd8e6;\n  border-radius: 4px;\n  color: #1d3d5c;\n  cursor: pointer;\n  font-weight: 700;\n  padding: 8px 12px;\n}\n\n.row-detail {\n  background: #f7fbff;\n  border-top: 1px solid #e1ebf5;\n  color: #36546e;\n  font-size: 13px;\n  padding: 12px 16px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/src/app/examples/animated-rows/animated-rows.component.css
// module id = ../../../../../src/app/examples/animated-rows/animated-rows.component.css
// module chunks = main